import React from "react";

import { Link as RRDLink, LinkProps as RRDLinkProps } from "react-router-dom";
import classnames from "classnames";

import { useWombatTheme } from "../../theme";

export type LinkVariant = "base" | "button" | "button-subtle" | "ghost";

type LinkProps = RRDLinkProps & {
  variant?: LinkVariant;
  id?: string;
  disabled?: boolean;
  className?: string;
  overrideClassName?: string;
};

const Link: React.FC<LinkProps> = ({
  children,
  id,
  variant = "base",
  disabled = false,
  className,
  overrideClassName,
  ...props
}) => {
  const { theme } = useWombatTheme();

  const linkStyle = classnames(theme.link[variant], className);

  if (disabled) {
    return (
      <span id={id} className={overrideClassName || linkStyle} {...props}>
        {children}
      </span>
    );
  }
  return (
    <RRDLink id={id} className={overrideClassName || linkStyle} {...props}>
      {children}
    </RRDLink>
  );
};

export default React.memo(Link);
